import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectorLoadingPackages,
  selectorPackageIds,
  selectorPendingIds,
  selectorShopBooks,
  selectorShopIds,
  selectorShopIsPackagesFetched,
  selectorShopPackages
} from "@/shared/store/shop/selectors";
import { isBookPermissionPurchaseOK } from "@/shared/utils/content/content";
import { _sharedActionsShop } from "@/shared/store/shop/actions";

const findPackageForBook = (shopPackages, packageIds, book_id) => {
  for (let i = 0; i < packageIds.length; i++) {
    const shopPackage = shopPackages[packageIds[i]];
    /* eslint-disable-next-line */
    const found = shopPackage.items.find((shopBook) => shopBook.book_id === book_id);
    if (found) {
      return {
        shopPackage,
        packageShopBookIds: shopPackage.items.map((shopBook) => shopBook.book_id),
      };
    }
  }

  return {
    shopPackage: null,
    packageShopBookIds: []
  };
};

export const useShopBook = (book) => {
  const dispatch = useDispatch();
  const shopBooks = useSelector(selectorShopBooks);
  const shopIds = useSelector(selectorShopIds);
  const pendingIds = useSelector(selectorPendingIds);
  const packageIds = useSelector(selectorPackageIds);
  const loadingPackages = useSelector(selectorLoadingPackages);
  const shopPackages = useSelector(selectorShopPackages);
  const isPackagesFetched = useSelector(selectorShopIsPackagesFetched);
  const bookId = book?.book_id;
  const shopBook = shopBooks[bookId];
  // if packages are fetched and there is no {shopBook},
  // then consider this book is not purchased.
  const isBookPermissionAuthOKValue = isBookPermissionPurchaseOK(shopBook);
  const {
    shopPackage,
    packageShopBookIds
  } = findPackageForBook(
    shopPackages,
    packageIds,
    book?.book_id,
  );
  const loading = pendingIds.has(bookId) || loadingPackages;

  const isForSale = book?.isForSale;

  useEffect(() => {
    if (!loading && bookId && isForSale && !shopBook && !isPackagesFetched) {
      const booksToFetch = [bookId];
      dispatch(_sharedActionsShop.fetchShopBooks(booksToFetch));
    }
  }, [shopIds, loading, bookId, book, shopBook, isPackagesFetched]);

  return {
    shopBook,
    shopBooks,
    isAvailable: isBookPermissionAuthOKValue,
    shopPackage,
    packageShopBookIds,
    packageIds,
    loading,
    isForSaleAndPurchased: isForSale && isBookPermissionAuthOKValue
  };
};
